import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { selectHolidays } from '../../utils/selectors/locale'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import Table from './Table'
import Calendar from './Calendar'
import { __ } from '../../services/translate'

class Holiday extends Component {
  constructor(props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = {
      activeTab: 'calendar'
    }
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  render() {
    return (
      <Fragment>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={this.state.activeTab === 'calendar' ? 'active' : ''}
              onClick={() => {
                this.toggle('calendar')
              }}
            >
              {__('Kalendář')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={this.state.activeTab === 'list' ? 'active' : ''}
              onClick={() => {
                this.toggle('list')
              }}
            >
              {__('Zoznam svátků')}
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="calendar">
            <Calendar
              holidays={this.props.holidays}
              lang={this.props.selectedLanguageSlug}
            />
          </TabPane>
          <TabPane tabId="list">
            <Table holidays={this.props.holidays}/>
          </TabPane>
        </TabContent>
      </Fragment>
    )
  }
}

const mapsStateToProps = (state) => ({
  holidays: selectHolidays(state.locale),
  selectedLanguageSlug: state.locale.selectedLanguage.slug
})

export default connect(mapsStateToProps)(Holiday)
